import {
    Box,
    Button,
    IconButton
} from '@mui/material';
import { useFieldValue } from 'components/form/input/NestedField';
import AddIcon from "@mui/icons-material/Add";
import React from 'react'
import { useState } from 'react';
import EntitySearchInput from 'components/form/EntitySearch/EntitySearchInput';
import Perfil from 'entity/Perfil';
import { useEffect } from 'react';

import DeleteIcon from "@mui/icons-material/Delete";
function CardPerfil({ perfil, perfisLoaded, removePerfil, mantemPerfil }) {
    let perfilUsar = perfisLoaded[perfil.uid] || perfil
    return (
        <Box sx={{ display: 'flex', p: 2, mb: 1, boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)', borderRadius: '5px' }}>
            {mantemPerfil !== perfilUsar.uid &&
                <IconButton onClick={() => removePerfil(perfilUsar.uid)}>
                    <DeleteIcon />
                </IconButton>
            }
            <div>

                <div>{perfilUsar.nome || perfilUsar.uid}</div>
                <div>{perfilUsar.email || perfilUsar.uid}</div>
            </div>
        </Box>


    )
}
export default function PerfilAutorizado({ name, label, mantemPerfil }) {

    let [items, setItems] = useFieldValue(name);
    let [perfilAdd, setPerfilAdd] = useFieldValue('tempAdd');
    const [perfis, setPerfis] = useState([])
    const [perfisLoaded, setPerfisLoaded] = useState({})



    useEffect(() => {

        if (items) {
            let p = Object.keys(items).map(v => { return { uid: v, perm: items[v] } }).filter(v => v.perm)
            p.forEach(p => {
                if (!perfisLoaded[p.uid])
                    Perfil.get(p.uid).then(perfilGet => {
                        setPerfisLoaded(old => {
                            let cp = { ...old }
                            cp[p.uid] = perfilGet.data
                            return cp;
                        })
                    })
            });
            setPerfis(p)
        }

        return () => {
            setPerfis([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items])

    function addItem() {

        if (perfilAdd) {

            let cp = { ...items }
            cp[perfilAdd.uid] = true;

            setItems(cp)
            setPerfilAdd(null)
        }

    }
    function removePerfil(uid) {
        let cp = { ...items }
        cp[uid] = false;
        setItems(cp)
    }

    return (
        <Box >

            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1, gap: 2 }}>
                <EntitySearchInput name="tempAdd" label={label || "Adicionar Usuário"} fieldFilterAdd={"email"} EntityClass={Perfil} />
                <Button variant="outlined" startIcon={<AddIcon />} onClick={() => addItem()}>
                    Adicionar
                </Button>
            </Box>

            {perfis.map((p, index) => <CardPerfil key={index} perfil={p} perfisLoaded={perfisLoaded} removePerfil={removePerfil} mantemPerfil={mantemPerfil} />)}
        </Box>



    )
}
